import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

import { IconButton, Snackbar } from '@mui/material';

export const SnackbarWithContext = ({ message, open, setOpen }) => {
  const onClose = () => {
    // if it's open, then close it!
    if (open) {
      setOpen(prev => !prev);
    }
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      ContentProps={{
        'aria-describedby': 'message-id',
      }}
      message={<span id="message-id">{message}</span>}
      action={[
        <IconButton
          key="close"
          size="large"
          aria-label="Close"
          color="inherit"
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>,
      ]}
    />
  );
};
